import React, { ReactNode } from "react";
import styled from "styled-components/macro";

type Props = { children?: ReactNode } & (
  | {
      canResize: true;
      open: boolean;
      onClickExpander: () => void;
      className?: string;
      fullHeight?: boolean;
    }
  | {
      canResize?: false;
      fullHeight?: boolean;
      open?: undefined;
      onClickExpander?: undefined;
      className?: string;
    }
);

const CommonSidebar = styled.div`
  transition: all 0.5s ease;
  background-color: var(--page-background);
  padding: 0 1.5rem;
  flex-direction: column;
  position: relative;
  border-left: 1px solid var(--border-gray-light);
  overflow-y: auto;
`;

type StyledProps = Pick<Props, "open" | "canResize" | "fullHeight">;

export const StyledRightSidebar = styled(CommonSidebar)<StyledProps>`
  min-width: ${({ open }) => (open ? "50vw" : "25vw")};
  max-height: ${({ fullHeight }) =>
    fullHeight ? "100vh" : "calc(100vh - var(--header-height))"};

  span.expander {
    cursor: pointer;
    display: ${({ canResize }) => (canResize ? "block" : "none")};
    position: absolute;
    border: 1px solid var(--border-gray-light);
    border-radius: 50%;
    background-image: ${({ open }) =>
      open
        ? "url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2aWV3Qm94PSIyIDYuNDIgNi43NjYgMTEuNDgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTSA4Ljc2NiA3LjQ0NiBMIDcuNzQgNi40MiBMIDIgMTIuMTYgTCA3Ljc0IDE3LjkgTCA4Ljc2NiAxNi44NzQgTCA0LjA1MiAxMi4xNiBaIiBzdHlsZT0iIiB0cmFuc2Zvcm09Im1hdHJpeCgtMSwgMCwgMCwgLTEsIDEwLjc2NiwgMjQuMzIpIi8+Cjwvc3ZnPg==)"
        : "url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2aWV3Qm94PSIyIDYuNDIgNi43NjYgMTEuNDgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTSA4Ljc2NiA3LjQ0NiBMIDcuNzQgNi40MiBMIDIgMTIuMTYgTCA3Ljc0IDE3LjkgTCA4Ljc2NiAxNi44NzQgTCA0LjA1MiAxMi4xNiBaIiBzdHlsZT0iIi8+Cjwvc3ZnPg==)"};
    background-color: var(--page-background);
    background-size: 30%;
    background-position: ${({ open }) => (open ? "55% 50%" : "45% 50%")};
    background-repeat: no-repeat;
    width: 2rem;
    height: 2rem;
    left: -0.5rem;
    top: calc(50% - 1rem);
  }

  @media only screen and (max-width: 640px) {
    height: auto;
    padding: 1.5rem 1.5rem 6rem 1.5rem;
  }
`;

export const StyledRightSidebarWithToggle = styled(CommonSidebar)<{
  show: boolean;
}>`
  display: ${({ show }) => (show ? "flex" : "none")};
  min-width: 20vw;
`;

export const RightSidebar: React.FC<Props> = ({
  onClickExpander,
  children,
  canResize,
  open,
  className,
  fullHeight,
}) => {
  return (
    <StyledRightSidebar
      className={className}
      open={open}
      canResize={canResize}
      fullHeight={fullHeight}
    >
      <span className="expander" onClick={onClickExpander || undefined} />
      {children}
    </StyledRightSidebar>
  );
};

export const RightSidebarWithToggle: React.FC<{ show: boolean }> = ({
  show,
  children,
}) => {
  return (
    <StyledRightSidebarWithToggle show={show}>
      {children}
    </StyledRightSidebarWithToggle>
  );
};
